<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="8" nzXl="10">
        <h1 class="page-title">Dashboard</h1>
    </div>
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="18" nzLg="16" nzXl="14" class="btnsearch">
        <div class="header-right-box">
            <input type="text" class="right_margin search-input" nz-input
                placeholder="Search here by type at least 3 character ..." [(ngModel)]="searchText"
                (keyup)="onSearch($event)" />
            <i nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip
                nzTooltipTitle="You need to wait for 3 seconds after search apply"></i>
        </div>
    </div>
</div>

<div class="table-height dashboard" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScrollDown()">
    <nz-table class="main-table-header" [nzData]="lst_Dashboard" [nzFrontPagination]="false" [nzShowPagination]="false"
        [ngClass]="{'table-loading' : lst_Dashboard.length > 0 || isDashboardLoaded}">
        <!-- <div class="table-height" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScrollDown()">
    <nz-table class="main-table-header" #sortTable [nzData]="lst_Dashboard" nzTableLayout="fixed"
        [nzFrontPagination]="false" [nzShowPagination]="false"
        [ngClass]="{'table-loading' : lst_Stock.length > 0 || isDashboardLoaded}"> -->
        <thead class="tablehead">
            <tr class="tableheader">
                <th nzWidth="150px" rowSpan="2" [nzAlign]="'left'" (nzSortOrderChange)="sort('name')" [nzSortFn]="true">
                    <span class="stock-name-th"> Part Number</span>
                </th>
                <th [nzAlign]="'center'" colSpan="2" class="pointer" (click)="showModal('626a836e3f8ecad9dda95f74')">In
                    Warehouse</th>
                <th [nzAlign]="'right'" rowSpan="2">Available</th>
                <th [nzAlign]="'right'" *ngFor="let s of lst_Stock;let i = index;" style="width: 50px;">
                    <span (click)="showModal(s.stockId)" class="pointer">{{s.name}}</span><br>
                    <a nzType="default" class="link containerNumber ellipsis" *ngIf="s.containerNumber" target="_blank"
                        [href]="'https://www.oecgroup.com/tracking/cntr/'+s.containerNumber+''">{{ s.containerNumber
                        }}</a>
                </th>
                <!--'64e2ede989f2cc30cb03ff0c'-->
                <th [nzAlign]="'center'" colSpan="2" class="pointer" (click)="showN2OModal()">N2O</th>
            </tr>
            <tr class="tableheader2">
                <th [nzAlign]="'right'">Total</th>
                <th [nzAlign]="'right'">Assigned</th>
                <th [nzAlign]="'right'" *ngFor="let s of lst_Stock;let i = index;" nzEllipsis rowSpan="2">
                    <span> Ordered (Assigned) </span>
                </th>
                <th>Assigned</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td [nzAlign]="'left'">Stock Location</td>
                <td></td>
                <td></td>
                <td></td>
                <td [nzAlign]="'right'" *ngFor="let s of lst_Stock;let i = index;">
                    {{ s.status == stockLocation.OnProduction ? 'In Production' : (s.status == stockLocation.InWarehouse
                    ?
                    'In Warehouse' : 'On Water' )}}
                </td>
                <td></td>
            </tr>
            <tr>
                <td [nzAlign]="'left'">ETA Date</td>
                <td></td>
                <td></td>
                <td></td>
                <td [nzAlign]="'right'" *ngFor="let s of lst_Stock;let i = index;">{{s.etaDate | date : 'MM/dd/yyyy' }}
                </td>
                <td></td>
            </tr>
            <tr *ngFor="let data of lst_Dashboard;let i = index;let even = even;" [ngClass]="{'is-even-row': even}">
                <td [nzAlign]="'left'">{{ data.partNumber }}</td>
                <td [nzAlign]="'right'">{{ data.inWarehouseQuantity }}</td>
                <td [nzAlign]="'right'">
                    <a nzType="link" nz-button nz-popover [nzPopoverTitle]="titleTemplate" class="pointer"
                        *ngIf="data.warehouseAssignedQuantity > 0" [nzPopoverPlacement]="'rightTop'"
                        [(nzPopoverVisible)]="data.visibleAssigned"
                        (nzPopoverVisibleChange)="changeDahboardAssigned($event,i)"
                        [nzPopoverContent]="contentTemplateWarehouse">{{ data.warehouseAssignedQuantity }}
                    </a>
                    <a class="restrict-pointer" nzType="link" nz-button *ngIf="data.warehouseAssignedQuantity== 0">0</a>
                    <div class="assiged-list-heigth">
                        <ng-template #titleTemplate>
                            Assigned To <img class="float-right close-icon" src="./assets/images/Close.svg"
                                (click)="changeDahboardAssigned(false,i)">
                        </ng-template>
                        <ng-template #contentTemplateWarehouse>
                            <ng-container *ngFor="let assign of data.assignedData">
                                <p *ngFor="let a of assign.assignmentList; let ai = index;">
                                    <span
                                        [ngClass]="{'pay-paid' :a.qB_PaymentStatus == 'Paid', 'pay-unpaid' :a.qB_PaymentStatus == 'UnPaid','pay-partial' :a.qB_PaymentStatus == 'PartiallyPaid'}">
                                        <i nzTheme="fill" nz-icon nzType="user" nzTheme="outline"
                                            class="right_margin"></i>
                                        <a class="assignlink"
                                            [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+a.transactionID"
                                            target="_blank">{{a.invoiceNo }}</a> - {{a.customerName }} - <a
                                            (click)="showAssignmentEdit(a,data)">({{a.assignedQuantity
                                            }})</a></span>
                                </p>
                                <div *ngIf="data.assignedData.length == 0">
                                    <span class="no-any-assignment">No any assignment</span>
                                </div>
                            </ng-container>
                            <i nz-icon [nzType]="'loading'" *ngIf="!data.assignedData "></i>
                        </ng-template>
                    </div>
                </td>
                <td [nzAlign]="'right'">{{ data.availableQuantity }}</td>
                <td [nzAlign]="'right'" *ngFor="let stock of lst_Stock;let s = index;">
                    <a class="mr--1 orderedQuantity" nz-button nzType="link">
                        <ng-container *ngFor="let i of stock.partNumbers;let p = index;">
                            <span *ngIf="data.partNumber == i.partNumber" nz-popover [nzPopoverTitle]="titleTemplate"
                                [nzPopoverPlacement]="'rightTop'" [(nzPopoverVisible)]="i.visibleAssigned"
                                (nzPopoverVisibleChange)="changeAssigned($event,s,p)"
                                [nzPopoverContent]="contentTemplate">
                                {{
                                i.orderedQuantity}}({{i.totalAssignedQuantity}})</span>
                            <ng-template #titleTemplate>
                                Assigned To <img class="float-right close-icon" src="./assets/images/Close.svg"
                                    (click)="changeAssigned(false,s,p)">
                            </ng-template>
                            <ng-template #contentTemplate>
                                <ng-container *ngIf="assignedData">
                                    <span class="text-assign">Total Assigned : {{assignedData.totalAssignedQuantity ?
                                        assignedData.totalAssignedQuantity : 0}}</span>
                                    <p *ngFor="let a of assignedData.assignmentList; let ai = index;">
                                        <span
                                            [ngClass]="{'pay-paid' :a.qB_PaymentStatus == 'Paid', 'pay-unpaid' :a.qB_PaymentStatus == 'UnPaid','pay-partial' :a.qB_PaymentStatus == 'PartiallyPaid'}">
                                            <i nzTheme="fill" nz-icon nzType="user" nzTheme="outline"
                                                class="right_margin"></i><a class="assignlink"
                                                [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+a.transactionID"
                                                target="_blank">{{ a.invoiceNo }}</a> - {{a.customerName }} -
                                            <a (click)="showAssignmentEdit(a,a)">({{a.assignedQuantity}})</a> </span>
                                    </p>
                                    <div
                                        *ngIf="assignedData && !assignedData.assignmentList || assignedData.assignmentList && assignedData.assignmentList.length == 0">
                                        <span class="no-any-assignment">No any assignment</span>
                                    </div>
                                </ng-container>
                                <i nz-icon [nzType]="'loading'" *ngIf="!assignedData"></i>
                            </ng-template>
                        </ng-container>
                    </a>
                </td>
                <td [nzAlign]="'right'">
                    <a nzType="link" nz-button nz-popover [nzPopoverTitle]="titleTemplateN2O" class="pointer"
                        *ngIf="data.n2OAssignedQuantity > 0" [nzPopoverPlacement]="'rightTop'"
                        [(nzPopoverVisible)]="data.visibleN2OAssigned"
                        (nzPopoverVisibleChange)="changeN2OAssigned($event,i)" [nzPopoverContent]="contentTemplateN2O">({{
                        data.n2OAssignedQuantity }})
                    </a>
                    <a class="restrict-pointer" nzType="link" nz-button *ngIf="data.n2OAssignedQuantity== 0">0</a>
                    <div class="assiged-list-heigth">
                        <ng-template #titleTemplateN2O>
                            Assigned To <img class="float-right close-icon" src="./assets/images/Close.svg"
                                (click)="changeN2OAssigned(false,i)">
                        </ng-template>
                        <ng-template #contentTemplateN2O>
                            <ng-container *ngFor="let assign of data.assignedData">
                                <p *ngFor="let a of assign.assignmentList; let ai = index;">
                                    <span
                                        [ngClass]="{'pay-paid' :a.qB_PaymentStatus == 'Paid', 'pay-unpaid' :a.qB_PaymentStatus == 'UnPaid','pay-partial' :a.qB_PaymentStatus == 'PartiallyPaid'}">
                                        <i nzTheme="fill" nz-icon nzType="user" nzTheme="outline"
                                            class="right_margin"></i>
                                        <a class="assignlink"
                                            [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+a.transactionID"
                                            target="_blank">{{a.invoiceNo }}</a> - {{a.customerName }} - <a
                                            (click)="showAssignmentEdit(a,data)">({{a.assignedQuantity
                                            }})</a></span>
                                </p>
                                <div *ngIf="data.assignedData.length == 0">
                                    <span class="no-any-assignment">No any assignment</span>
                                </div>
                            </ng-container>
                            <i nz-icon [nzType]="'loading'" *ngIf="!data.assignedData "></i>
                        </ng-template>
                    </div>
                </td>
            </tr>
        </tbody>
        <ng-container *ngIf="isDashboardLoaded">
            <tbody>
                <tr *ngFor="let i of [].constructor(100)">
                    <ng-container *ngFor="let i of [].constructor(lst_Stock.length + 5)">
                        <td [nzAlign]="'left'" class="loading">
                            <div class="bar"></div>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </ng-container>
    </nz-table>
</div>
<nz-modal nzCentered [nzVisible]="isVisible" [nzWidth]="1000" (nzOnCancel)="handleCancel()"
    nzClassName="StockAssignmentModal" nzTitle="Stock Assignments" [nzFooter]="null">
    <ng-container *nzModalContent class="custom-modal">
        <!-- <div class="previewFile"> -->
        <div nz-row>
            <div nz-col nzSpan="24">
                <strong class="stock-name ng-star-inserted">Stock {{stockAssignment?.name}}</strong>
            </div>
        </div>
        <div nz-row>
            <div nz-col nzSpan="24" class="warehousescreen">
                <div class="table-height">
                    <nz-table class="main-table-header" [nzData]="stockAssignment?.stockPartNumbers"
                        [ngClass]="{'table-loading' : lst_Stock.length > 0 || isStockLoaded}"
                        [nzShowPagination]="false">
                        <thead class="tableheader">
                            <tr class="tableheader">
                                <th nzWidth="50px">#</th>
                                <th nzWidth="200px" [nzAlign]="'left'" [nzSortFn]="true"
                                    (nzSortOrderChange)="stockAssignment?.name != 'N2O' ? sortPart(!isAscPart,stockAssignment?.stockPartNumbers) : sortN2OPartNumber()">
                                    <span class="stock-name-th">Part Number</span>
                                </th>
                                <th *ngIf="stockAssignment?.name != 'N2O'" [nzAlign]="'right'" nzWidth="80px">Ordered
                                </th>
                                <th *ngIf="stockAssignment?.name != 'N2O'" [nzAlign]="'right'" nzWidth="80px">Assigned
                                </th>
                                <th *ngIf="stockAssignment?.name != 'N2O'" [nzAlign]="'right'" nzWidth="100px">Available
                                </th>
                                <!-- <th [nzAlign]="'left'"  nzWidth="100px" >Notes</th> -->
                                <th [nzAlign]="'left'" nzWidth="300px">Assignment</th>
                                <th *ngIf="stockAssignment?.name == 'N2O'" nzWidth="200px">Is Ordered From Factory - PI Number
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngIf="!isStockLoaded">
                            <tr *ngFor="let stockAssignmen of stockAssignment?.stockPartNumbers;let  i = index;">
                                <td nzWidth="50px">{{i+1}}</td>
                                <td nzWidth="200px">{{stockAssignmen.partNumber}}</td>
                                <td *ngIf="stockAssignment?.name != 'N2O'" nzWidth="80px" [nzAlign]="'right'">
                                    {{stockAssignmen.orderedQuantity}}</td>
                                <td *ngIf="stockAssignment?.name != 'N2O'" nzWidth="80px" [nzAlign]="'right'">
                                    {{stockAssignmen.totalAssignedQuantity}}</td>
                                <td *ngIf="stockAssignment?.name != 'N2O'" nzWidth="100px" [nzAlign]="'right'">
                                    {{stockAssignmen.orderedQuantity-stockAssignmen.totalAssignedQuantity}}</td>
                                <!-- <td nzWidth="100px" nzEllipsis>{{stockAssignmen.note}}</td> -->
                                <td nzWidth="300px">
                                    <p *ngFor="let a of stockAssignmen.stockPartNumberAssignmentsStock; let ai = index;"
                                        class="stockAssignmenlst">
                                        <span
                                            [ngClass]="{'pay-paid' :a.qB_PaymentStatus == 'Paid', 'pay-unpaid' :a.qB_PaymentStatus == 'UnPaid','pay-partial' :a.qB_PaymentStatus == 'PartiallyPaid'}">
                                            <i nzTheme="fill" nz-icon nzType="user" nzTheme="outline"
                                                class="right_margin"></i>
                                            <a class="assignlink"
                                                [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+a.transactionID"
                                                target="_blank">{{ a.invoiceNo }}</a> - {{a.customerName }} - <a
                                                (click)="showAssignmentEdit(a,stockAssignment)">({{a.assignedQuantity}})</a></span>
                                        
                                    </p>
                                </td>
                                <td *ngIf="stockAssignment?.name == 'N2O'">
                                    <p *ngFor="let a of stockAssignmen.stockPartNumberAssignmentsStock; let ai = index;">
                                    <label *ngIf="stockAssignment?.name == 'N2O'" class="pr-1" nz-checkbox
                                            [(ngModel)]="a.isChecked" [nzDisabled]="!(a.piNumber == '' || a.piNumber == null)"
                                            (ngModelChange)="saveSelectedPI(a,stockAssignmen)"></label>
                                            <!--(click)="startEdit(a.transactionID, a.piNumber);a.addPIClicked = true"
                                            [hidden]="editId === a.transactionID"-->
                                        <!-- <span [hidden]="editId === a.transactionID" (click)="startEdit(a.transactionID, a.tempPINumber)" *ngIf="a.piNumber != ''"
                                            >{{a.piNumber}}</span> -->
                                        <!-- <span *ngIf="a.piNumber == '' && a.isChecked" (click)="startEdit(a.transactionID, a.piNumber);a.addPIClicked = true"><i nz-icon
                                            nzType="plus-circle" nzTheme="outline"></i> Add PI Number</span> -->
                                            <!--[hidden]="editId !== a.transactionID"-->
                                        <input *ngIf="a.isChecked" style="width:50%;margin: 3px;
                                        height: 30px;" nz-input (blur)="saveSelectedPI(a, stockAssignmen)"
                                             placeholder="Enter PI Number" [(ngModel)]="a.tempPINumber" />
                                        </p>
                                </td>
                            </tr>
                        </tbody>
                        <ng-container *ngIf="isStockLoaded">
                            <tbody>
                                <tr *ngFor="let i of [].constructor(3)">
                                    <ng-container *ngFor="let i of [].constructor(stockAssignment?.name != 'N2O' ? 6: 4)">
                                        <td [nzAlign]="'left'" class="loading">
                                            <div class="bar"></div>
                                        </td>
                                    </ng-container>
                                </tr>
                            </tbody>
                        </ng-container>
                    </nz-table>
                </div>
            </div>
        </div>

        <!-- </div> -->
    </ng-container>
</nz-modal>

<!-- <nz-modal [(nzVisible)]="isVisible" nzTitle="The first Modal" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" class="physicalInventoryModal">
    <ng-container *nzModalContent>
      <p>Content one</p>
      <p>Content two</p>
      <p>Content three</p>
    </ng-container>
  </nz-modal> -->
<app-add-update-assignment *ngIf="isAssignmentVisible" [editAssignmentDetail]="editAssignmentDetail"
    (hideModal)="hideModal($event)">
</app-add-update-assignment>